export enum LargeExportsVariantsEnum {
    APPS = 'Apps',
    CSV = 'Csv',
    PREVIEW = 'Preview',
    SALESFORCE = 'SALESFORCE',
    HUBSPOT = 'HUBSPOT',
}
